import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useCallback, useContext } from "react";
import { RootStoreContext } from "src/stores/RootStore";
import { FileSelectorContainer } from "src/components/fileSelector/FileSelectorContainer";
import { FileSelectorItem } from "src/components/fileSelector/FileSelectorItem";
import { IFile } from "src/types";
import { TICKET_PROPERTY } from "src/stores/TicketStore";
import { SCREEN_SIZE } from "src/stores/UIStore";
import { FILE_TYPE } from "src/enums";

const TicketDocumentSectionBase = () => {
    const { t } = useTranslation();
    const { uiStore, ticketStore } = useContext(RootStoreContext);

    const onSelectNewIncidentFile = useCallback(
        (newIncidentFile: IFile) => {
            ticketStore.currentTicket?.updateProperty(TICKET_PROPERTY.INCIDENT_FILES, newIncidentFile);
        },
        [ticketStore.currentTicket]
    );

    const onDeleteIncidentFile = useCallback(
        async (fileId: string) => {
            await ticketStore.currentTicket?.removeIncidentFile(fileId);
        },
        [ticketStore.currentTicket]
    );

    return (
        <div className={"p-3"}>
            <div id="incident-files-list">
                <FileSelectorContainer
                    style={uiStore.currentScreenSize <= SCREEN_SIZE.MOBILE_L ? { justifyContent: "end" } : {}}
                >
                    {/* Currently selected / loaded Incidentfiles */}
                    {ticketStore.currentTicket?.incidentFiles?.map((incidentFile) => (
                        <FileSelectorItem
                            key={incidentFile.fileId}
                            label={incidentFile.name ?? "-"}
                            fileType={FILE_TYPE.INCIDENT_FILE}
                            file={incidentFile}
                            onDeleteFilePropFunc={onDeleteIncidentFile}
                            canDelete={ticketStore.isEditing ? true : false}
                            fileSelectorItemStyles={{ width: "160px", height: "140px" }}
                        />
                    ))}

                    {/* FileSelectorItem to add new incidentfiles */}
                    {ticketStore.isEditing && (
                        <FileSelectorItem
                            key={"add-new-incident-file"}
                            label={t("screens.tickets.form.documents.additional_documents").toString()}
                            fileType={FILE_TYPE.INCIDENT_FILE}
                            file={undefined}
                            onSelectNewFilePropFunc={onSelectNewIncidentFile}
                            fileSelectorItemStyles={{ width: "160px", height: "140px" }}
                            allowAllFileTypes={true}
                        />
                    )}
                </FileSelectorContainer>
            </div>
        </div>
    );
};

export const TicketDocumentSection = Sentry.withProfiler(observer(TicketDocumentSectionBase));
